import { ColDef } from 'ag-grid-community'
import { DateCellComponent } from '../cells/date-cell.component'
import { TableHeaderComponent } from '../headers/table-header.component'
import { dateTimeWithoutTimezone } from '../../../shared/utilities/date'
import { IntervalUsageHistory } from 'src/app/shared/models/intervalUsageHistory'
import { NumberCellComponent } from '../cells/number-cell.component'
import { IntervalUsage } from 'src/app/shared/models/intervalUsage'

export const filterGroup = 'interval_usage_history'

export class IntervalUsageHistoryColumnDefinition {

  sharedDef: ColDef = {
    filter: false,
    sortable: false,
    editable: false,
    minWidth: 100,
    width: 150,
  }

  getColDefs = (): ColDef[] => [
    {
      ...this.sharedDef,
      headerName: 'Usage (kW\u00A0h)',
      field: 'measurement_value',
      cellRenderer: NumberCellComponent,
      cellRendererParams: {
        num: (d: IntervalUsage) => d.measurement_value,
        precision: 8,
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      width: 175,
      headerName: 'Last Updated At (STL)',
      field: 'last_update_time',
      cellRenderer: DateCellComponent,
      cellRendererParams: {
        format: dateTimeWithoutTimezone,
        date: (d: IntervalUsageHistory) => d.last_update_time,
        viewAsTz: 'America/Chicago',
      },
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
    {
      ...this.sharedDef,
      width: 175,
      flex: 1,
      headerName: 'Last Updated By',
      field: 'last_updated_by',
      headerComponent: TableHeaderComponent,
      headerComponentParams: {
        filterGroup,
      },
    },
  ]
}
